<template>
  <div class="pay">
    <div class="top"></div>
    <van-nav-bar
      title="提交订单"
      left-text="返回"
      left-arrow
      :fixed="true"
      @click-left="back"
      z-index=0
    />
    <div class="address-box">
      <div class="address">
        <div
          class="clearfix"
          @click="openAddressBox"
        >
          <div class="fl address-title">选择收货地址</div>
          <div class="fl arrow-box">
            <van-icon
              name="arrow"
              class="arrow-icon"
            />
          </div>
        </div>
        <div class="address-content">
          <div class="clearfix">
            <div class="fl name">{{currentAddress.name}}</div>
            <div class="fl phone">{{currentAddress.tel}}</div>
          </div>
          <div class="address-info">{{currentAddress.address}}</div>
        </div>
      </div>
    </div>
    <div class="order-info">
      <div class="order-box">
        <div class="order-title">订单信息</div>
        <div>
          <div
            class="clearfix cell-box"
            v-for="(item,index) in shopbagData"
            :key="index"
          >
            <div class="fl pro-img">
              <img
                class="auto-img"
                :src="item.small_img"
                alt=""
              >
            </div>
            <div class="fl pro-info">
              <div class="text-box">
                <div class="clearfix">
                  <div class="fl text-name">{{item.name}}</div>
                  <div class="fl text-rule">{{item.rule}}</div>
                </div>
                <div class="text-enname">{{item.enname}}</div>
              </div>
              <div class="price-box">
                <div class="fl price">￥{{item.price}}</div>
                <div class="fr count">
                  {{item.count}}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="pro-box">
          <div class="clearfix pro-boxing">
            <div class="fl pro-count">共计{{product.count}}件商品</div>
            <div class="fr pro-total">合计 ￥{{product.total}}</div>
          </div>
          <div class="circle-box left"></div>
          <div class="circle-box right"></div>
        </div>

      </div>
    </div>
    <div class="pay-btn">
      <van-button
        round
        block
        color="#0C34BA"
        @click="close(),showPupop()"
      >立即结算</van-button>
      <van-overlay
        :show="showpay"
        z-index=1
        duration=0.8
      >
        <div class="wrapper">
          <div
            class="box-overlay"
            @click.stop
          >
            <div
              class="box-close"
              @click="close"
            >x</div>
            <h3 class="box-title">请输入支付密码</h3>
            <div class="box-price">￥{{product.total}}</div>
            <!-- <div class="block"> -->
            <van-password-input
              :value="value"
              info="密码为 6 位数字"
              :focused="showKeyboard"
              @focus="showKeyboard = true"
              @blur="showKeyboard = false"
            />
            <van-button
              color="#0c34ba"
              block
              @click="payment"
            >确认支付</van-button>
            <!-- 数字键盘 -->
            <van-number-keyboard
              :show="showKeyboard"
              @input="onInput"
              @delete="onDelete"
              @blur="pay"
            />
          </div>
        </div>
        <!-- </div> -->
      </van-overlay>
    </div>

    <van-popup
      v-model="isOpen"
      position="bottom"
      closeable
      close-icon="close"
      round
    >
      <div class="popup-title">收货地址</div>
      <van-address-list
        v-model="chosenAddressId"
        :list="list"
        default-tag-text="默认"
        @select="selectAddress"
        @add="newAddress"
        @edit="editAddress"
      />
    </van-popup>
  </div>
</template>

<script>
import "../assets/less/pay.less";
import { utils } from "../assets/js/Utils";
export default {
  data() {
    return {
      isOpen: false,
      // 地址id
      chosenAddressId: "",
      // 地址列表数据
      list: [],
      // 选择地址数据
      currentAddress: {
        name: "",
        tel: "",
        address: "",
      },
      // 购物袋数据
      shopbagData: [],

      product: {
        count: 0,
        total: 0,
      },

      sids: [],

      // 弹出支付密码窗口
      showpay: false,

      value: "",
      // 数字键盘
      showKeyboard: false,
    };
  },
  created() {
    // 接收购物车传过来的商品id,以某个字符进行切割
    this.sids = this.$route.query.sids.split("-");

    // 查询收货地址
    this.getReceiveAddress();

    // 根据sids查询购物袋数据
    this.getShopbagDataBySids();
  },
  methods: {
    // 返回
    back() {
      this.$router.go(-1);
    },
    // 弹出选择地址
    openAddressBox() {
      this.isOpen = true;
    },

    // 选择地址 将选中的地址渲染到页面上
    selectAddress(item, index) {
      this.isOpen = false;

      for (let key in this.currentAddress) {
        this.currentAddress[key] = item[key];
      }
    },

    // 新增地址
    newAddress() {
      this.$router.push({ name: "NewAddress" });
    },

    // 查询收货地址
    getReceiveAddress() {
      // 获取token字符串
      let tokenString = localStorage.getItem("TK");
      if (!tokenString) {
        return;
      }

      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
        loadingType: "spinner",
      });
      this.axios({
        method: "GET",
        url: "/findAddress",
        params: {
          appkey: this.appkey,
          tokenString,
        },
      })
        .then((result) => {
          this.$toast.clear();

          if (result.data.code == 20000) {
            result.data.result.map((v) => {
              let address = v.province + v.city + v.county + v.addressDetail;
              this.list.push({
                id: v.aid,
                name: v.name,
                tel: v.tel,
                address,
                isDefault: Boolean(v.isDefault),
              });
              // 点击选择收货地址 把信息绑定上去
              if (Boolean(v.isDefault)) {
                this.chosenAddressId = v.aid;
                this.currentAddress.name = v.name;
                this.currentAddress.tel = v.tel;
                this.currentAddress.address = address;
              }
            });
          }
        })
        .catch((err) => {
          this.$toast.clear();
        });
    },

    // 根据sids查询购物袋数据
    getShopbagDataBySids() {
      // 获取token字符串
      let tokenString = localStorage.getItem("TK");
      if (!tokenString) {
        return;
      }
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
        duration: 0,
        loadingType: "spinner",
      });
      this.axios({
        method: "GET",
        url: "/commitShopcart",
        params: {
          appkey: this.appkey,
          tokenString,
          sids: JSON.stringify(this.sids),
        },
      })
        .then((result) => {
          this.$toast.clear();

          if (result.data.code == 50000) {
            if (result.data.result.length === 0) {
              return this.$router.push({ name: "Menu" });
            }

            result.data.result.map((v) => {
              this.product.count += v.count;
              this.product.total += v.count * v.price;
            });
            this.product.total = this.product.total + ".00";
            this.shopbagData = result.data.result;
          }
        })
        .catch((err) => {
          this.$toast.clear();
        });
    },

    // 立即结算
    showPupop() {
      if (this.chosenAddressId == "") {
        this.$toast("请选择收货地址");
        return;
      }
      this.showpay = true;
      setTimeout(() => {
        this.showKeyboard = true;
      }, 500);
    },

    // 确定支付
    pay() {
      if (this.value.length == 6) {
        // 获取token字符串
        let tokenString = localStorage.getItem("TK");
        if (!tokenString) {
          return;
        }

        let data = utils.queryString({
          appkey: this.appkey,
          tokenString,
          sids: JSON.stringify(this.sids),
          phone: this.currentAddress.tel,
          address: this.currentAddress.address,
          receiver: this.currentAddress,
        });

        this.$toast.loading({
          message: "加载中...",
          forbidClick: true,
          duration: 0,
          loadingType: "spinner",
        });
        this.axios({
          method: "POST",
          url: "/pay",
          data,
        })
          .then((result) => {
            this.$toast.clear();

            if (result.data.code == 60000) {
              this.$toast(result.data.msg);
              setTimeout(() => {
                this.$router.push({ name: "Order" });
              }, 2000);
            }
          })
          .catch((err) => {
            this.$toast.clear();
          });
      }
    },

    // 输入支付密码时
    onInput(key) {
      this.value = (this.value + key).slice(0, 6);
    },

    // 删除支付密码时
    onDelete() {
      this.value = this.value.slice(0, this.value.length - 1);
    },

    // 确认支付
    payment() {
      if (this.value == 6) {
        this.showpay = false;
      } else {
        this.$toast("请输入六位支付密码");
      }
    },

    // 关闭支付窗口
    close() {
      this.showpay = false;
      this.showKeyboard = false;
      this.value = "";
    },

    // 编辑地址
    editAddress(item) {
      this.$router.push({ name: "NewAddress", query: { aid: item.id } });
    },
  },
};
</script>